import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { BaseEntity } from '../base/BaseEntity'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { UserProfile } from './UserProfile'
import { UserStatusEnum } from './UserStatusEnum'
import { ObjectId } from '../base/ObjectId'
import { UserServices } from './UserServices'
import { Address } from '../address/Address'
import { Company } from '../company/Company'
import type { UserTypeEnum } from './UserTypeEnum'

@ObjectType()
@InputType('UserInput')
@modelOptions({
  schemaOptions: {
    timestamps: true,
    strict: false,
  },
})
export class User extends BaseEntity {
  @Field(() => ID)
  @Prop({ type: ObjectId, required: true, default: () => new ObjectId() })
  declare _id: string

  @Field(() => UserProfile)
  @Prop({ type: UserProfile })
  profile: UserProfile

  @Prop({ type: UserServices })
  services?: UserServices

  @Field(() => String)
  @Prop({ type: String, default: UserStatusEnum.pending })
  declare status: UserStatusEnum

  @Field(() => [String])
  @Prop({ type: [String] })
  roles: string[]

  @Field(() => String)
  @Prop({ type: String })
  tenantId: string

  @Field(() => String)
  @Prop({ type: String, default: 'America/Chicago' })
  timeZone: string

  @Field(() => String)
  @Prop({ type: String })
  type: UserTypeEnum

  @Field(() => String, { description: 'This will be stored as INTERNATIONAL formatting (e.g. +1 888-867-5309 ext. 123)' })
  @Prop({ type: String })
  phone: string

  /**
   * These are all the emails associated with the user
   */
  @Field(() => [String])
  @Prop({ type: [String] })
  emails: string[]

  @Field(() => String)
  @Prop({ type: String })
  stripeId: string

  @Field(() => String)
  @Prop({ type: String })
  qboId: string

  @Field(() => String)
  @Prop({ type: String })
  zendeskId: string

  @Field(() => Address)
  @Prop({ type: Address })
  address: Address

  @Field(() => [Address])
  @Prop({ type: [Address] })
  addresses: Address[]

  @Field(() => Company)
  @Prop({ type: Company })
  company: Company
}
